import { Dispatch } from 'redux'

import anchor from '../../../constants/anchor'
import { apiInstance } from '../../api/apiInstance'
import { RootState } from '../../store/rootReducer'
import { storeDispatchTypes } from '../../store/storeDispatchTypes'

const updateInventoryPartQty =
    (partId: string, qty: number) =>
    async (dispatch: Dispatch, getState: () => RootState): Promise<boolean> => {
        if (!Number.isFinite(qty) || qty < 0) {
            return false
        }

        const { userData } = getState()

        try {
            const {
                data: { status },
            } = await apiInstance.post(
                '/setPartExtraDataFieldValue',
                {
                    userId: userData.smsAuth.userId,
                    partId,
                    extraDataField: 'qty',
                    extraDataValue: qty,
                },
                {
                    headers: {
                        Authorization: `${anchor} ${localStorage.getItem('accessToken')}`,
                    },
                },
            )

            if (status === 'ok') {
                dispatch({
                    type: storeDispatchTypes.updateInventoryPartQty,
                    value: { partId, qty },
                })
                return true
            }

            return false
        } catch (e) {
            console.error('update inventory part qty failed', e)
            return false
        }
    }

export default updateInventoryPartQty
